/*
 * File: fascicle-block-status.component.ts                                  *
 * Project: catalog-cloud                                                      *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 */

import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { Fascicle } from '@nousmedis/cc-types';
import {
  FascicleBlockStatus,
  FascicleService,
} from '../../../services/fascicle.service';
@Component({
  selector: 'app-fascicle-block-status',
  templateUrl: './fascicle-block-status.component.html',
  styleUrls: ['./fascicle-block-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FascicleBlockStatusComponent {
  @Input() fascicle!: Fascicle;
  @Input() currentUserId!: string;

  @Output() requestUnblock = new EventEmitter<Fascicle>();
  @Output() forceUnblock = new EventEmitter<Fascicle>();

  constructor(private fascicleService: FascicleService) {}

  get blockStatus(): FascicleBlockStatus | null {
    return this.fascicleService.getBlockStatus(this.fascicle);
  }

  get canUnblock(): boolean {
    return this.fascicleService.canUnblock(this.currentUserId, this.fascicle);
  }
}
